import { Pipe, PipeTransform } from '@angular/core';

import { indexClass } from '../constants/constants';

@Pipe({ name: 'indexClass' })
export class IndexClassPipe implements PipeTransform {
  transform(
    stationIndex: number,
    stationId,
    parameter: string,
    hour,
    day: moment.Moment,
    showCurrent: boolean,
    matrixArray: any,
    mosData: any,
    stationTime: any,
    selectedTimeStep: number,
    selectedStationIndex: number,
    pigeonServiceDay: any,
    pigeonServiceMosData: any
  ) {
    return indexClass(
      stationIndex,
      stationId,
      parameter,
      hour,
      day,
      showCurrent,
      matrixArray,
      mosData,
      stationTime,
      selectedTimeStep,
      selectedStationIndex,
      pigeonServiceDay,
      pigeonServiceMosData
    );
  }
}
